import { jsx as _jsx } from "react/jsx-runtime";
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export const Spinner = React.memo(function Spinner() {
    return _jsx(FontAwesomeIcon, { icon: faSpinnerThird, spin: true });
});
